import { CompareFn } from './types'

const DEFAULT_MEDIA_STREAM_TRACK_COMPARE_FIELDS: Array<keyof MediaStreamTrack> = ['enabled', 'id', 'kind', 'muted']

export const compareMediaStreamTrack: CompareFn<MediaStreamTrack> = (
  a: MediaStreamTrack,
  b: MediaStreamTrack,
  ...byFieldsArg: Array<keyof MediaStreamTrack>
): boolean => {
  const byFields = byFieldsArg.length ? byFieldsArg : DEFAULT_MEDIA_STREAM_TRACK_COMPARE_FIELDS
  for (const key of byFields) {
    if (a[key] !== b[key]) {
      return false
    }
  }
  return true
}
